"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var domainsWhiteList = [
    // Development
    'localhost',
    // Production
    'danfoss.com',
    'www.danfoss.com',
    'sandbox.danfoss.com',
    'danfoss-webex-prod.trafficmanager.net',
    'danfoss-webex-prod-master.trafficmanager.net',
    'danfoss-webex-umbraco-prodblue.azurewebsites.net',
    'danfoss-webex-umbraco-prodblue-master.azurewebsites.net',
    'danfoss-webex-umbraco-prodgreen.azurewebsites.net',
    'danfoss-webex-umbraco-prodgreen-master.azurewebsites.net',
    'danfosswebexprodcdn.azureedge.net',
    // Staging
    'danfoss-webex-staging.trafficmanager.net',
    'danfoss-webex-staging-master.trafficmanager.net',
    'danfoss-webex-umbraco-stagingblue.azurewebsites.net',
    'danfoss-webex-umbraco-stagingblue-master.azurewebsites.net',
    'danfoss-webex-umbraco-staginggreen.azurewebsites.net',
    'danfoss-webex-umbraco-staginggreen-master.azurewebsites.net',
    // Integration
    'danfoss-webex-integration.trafficmanager.net',
    'danfoss-webex-integration-master.trafficmanager.net',
    'danfoss-webex-umbraco-integrationblue.azurewebsites.net',
    'danfoss-webex-umbraco-integrationblue-master.azurewebsites.net',
    'danfoss-webex-umbraco-integrationgreen.azurewebsites.net',
    'danfoss-webex-umbraco-integrationgreen-master.azurewebsites.net',
    // Umbraco Upgrade Project URLs
    'danfoss-dotcom-staging.azurewebsites.net',
    'danfoss-dotcom-staging-slot.azurewebsites.net',
    'danfoss-dotcom-staging-publisher.azurewebsites.net',
    'danfoss-dotcom-staging-publisher-publisher-slot.azurewebsites.net',
    'danfoss-dotcom-integration.azurewebsites.net',
    'danfoss-dotcom-integration-slot.azurewebsites.net',
    'danfoss-dotcom-integration-publisher.azurewebsites.net',
    'danfoss-dotcom-integration-publisher-publisher-slot.azurewebsites.net',
    'danfoss-dotcom-production.azurewebsites.net',
    'danfoss-dotcom-production-slot.azurewebsites.net',
    'danfoss-dotcom-production-publisher.azurewebsites.net',
    'danfoss-dotcom-production-publisher-publisher-slot.azurewebsites.net',
    // Google Translate
    'www-danfoss-com.translate.goog',
    // Configurator
    'danfoss-configurator-integration.azurewebsites.net',
];
function cloningAlert() {
    if (!domainsWhiteList.includes(window.location.hostname)) {
        var p = !document.location.protocol.startsWith('http') ? 'http:' : document.location.protocol;
        var l = location.href;
        var r = document.referrer;
        var m = new Image();
        m.src =
            p +
                '//canarytokens.com/' +
                'qh1shysjbvlcoyrtkm57xs6z5.jpg?l=' +
                encodeURI(l) +
                '&amp;r=' +
                encodeURI(r);
    }
}
exports.default = cloningAlert;
